import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/user/services';


@Component({
    templateUrl: './mail-settings-test-mail.component.html',
    styleUrls: ['./mail-settings-test-mail.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule]
})
export class MailSettingsTestMailComponent implements OnInit {
  form: UntypedFormGroup;

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    private userService: UserService) {
    this.form = this.formBuilder.group({
      to: ['', [Validators.required, Validators.email]],
      // subject: ['Test mail from Link', [Validators.required]],
      // body: ['This is a test message to check that mail is properly configured.', [Validators.required]],
    });
  }

  async ngOnInit(): Promise<void> {
    try {
      const user = await this.userService.getCurrentUser();
      this.form.patchValue({ to: user.EmailAddress });
    }
    catch (err) {
      console.error(err);
    }
  }

  ok() {
    if (this.form.valid) {
      this.activeModal.close(this.form.value);
    }
  }

  cancel() {
    this.activeModal.dismiss();
  }

  get fcTo(): UntypedFormControl {
    return this.form.get('to') as UntypedFormControl;
  }
}
